let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aqoew")).then(() => parcelRequire('7aYyj'));